import { useNavigate, useSearchParams } from "react-router";

export const useNavigateWithQueryParams = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	return (pathname: string, config?: { replace: boolean }) =>
		navigate({ pathname, search: `?${searchParams.toString()}` }, config);
};
